import { useState, useEffect } from 'react';

const useConfig = (configType) => {
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadConfig = async () => {
      try {
        // Config files are always served from the root config directory
        // regardless of the current route/URL path
        const configPath = `${process.env.PUBLIC_URL || ''}/config/${configType}.json`;
        
        const response = await fetch(configPath, {
          cache: 'no-cache',
          headers: {
            'Cache-Control': 'no-cache, no-store, must-revalidate',
            'Pragma': 'no-cache',
            'Expires': '0'
          }
        });
        if (!response.ok) {
          const text = await response.text();
          console.error('Server response:', text);
          throw new Error(`Failed to load configuration: ${response.status} ${response.statusText}`);
        }
        const data = await response.json();
        setConfig(data);
      } catch (err) {
        setError(err.message);
        console.error('Error loading configuration:', err);
      } finally {
        setLoading(false);
      }
    };

    loadConfig();
  }, [configType]);

  return { config, loading, error };
};

export default useConfig; 